import * as ActionType from "./role.type";

const initialState = {
  roles: [],
  totalRoles: 0,
  assignableRoles: [],
  isLoading: false,
};

export const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_ROLES:
      return {
        ...state,
        roles: action.payload.data,
        totalRoles: action.payload.total,
      };
    case ActionType.CREATE_ROLE:
      return {
        ...state,
        roles: [action.payload, ...state.roles],
        totalRoles: state.totalRoles + 1,
      };
    case ActionType.EDIT_ROLE:
      return {
        ...state,
        roles: state.roles.map((role) =>
          role._id === action.payload._id ? action.payload : role
        ),
      };
    case ActionType.DELETE_ROLE:
      return {
        ...state,
        roles: state.roles.filter((role) => role._id !== action.payload),
        totalRoles: state.totalRoles - 1,
      };
    case ActionType.UPDATE_ROLE_STATUS:
      return {
        ...state,
        roles: state.roles.map((role) =>
          role._id === action.payload ? { ...role, isActive: !role.isActive } :
          (role._id === action.payload._id ? action.payload : role)
        ),
      };
    case ActionType.GET_ELIGIBLE_ROLES:
      return {
        ...state,
        assignableRoles: action.payload,
      };
    default:
      return state;
  }
};
